module.exports = __webpack_public_path__ + "static/media/background_dashboard.18d7f09f.jpg";